import { Permission } from '../../libraries/user';

export class UserPermissionsHandler {
  permissions: Permission[];

  constructor(permissions: Permission[]) {
    this.permissions = permissions;
  }

  public hasSystemConfigPermissions = () => {
    return hasPermissions(1, 0x02, this.permissions);
  };

  public hasFinancialPermissions = () => {
    return hasPermissions(2, 0x01, this.permissions);
  };

  public hasCITPermissions = () => {
    return hasPermissions(2, 0x02, this.permissions);
  };

  public hasFinancialRemoteOperations = () => {
    return hasPermissions(2, 0x04, this.permissions);
  };

  public hasNonFinancialRemoteOperations = () => {
    return hasPermissions(1, 0x04, this.permissions) || this.hasHelpdesk();
  };

  public hasHelpdesk = () => {
    return hasPermissions(4, 0x08, this.permissions);
  };

  public hasHelpdeskAgent = () => {
    return hasPermissions(4, 0x10, this.permissions);
  };

  public hasProductManagement = () => {
    return hasPermissions(5, 0x01, this.permissions);
  };
}

/**
 * Verifies if logged user has permissions\
 * Returns true or false
 * @param {*} appId Application ID
 * @param {*} mask permission mask
 * @param {*} userPermissions option
 */
export const hasPermissions = function (appId: number, mask: number, userPermissions: any) {
  // if (!userPermissions) {
  //   userPermissions = JSON.parse(sessionStorage.userPermissions);
  // }
  if (!userPermissions) {
    return false;
  }
  for (let index = 0; index < userPermissions.length; index++) {
    let userPermission = userPermissions[index];
    if (appId === userPermission.appId) {
      return (userPermission.permissionCode & mask) !== 0;
    }
  }
};
